import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "block-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_info_sub_block = _resolveComponent("home-info-sub-block")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.data.title), 1),
      _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.values, (value) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_home_info_sub_block, { value: value }, null, 8, ["value"])
      ]))
    }), 256))
  ]))
}